(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-blog-posts"] && !window.DesignMode) return;
  try {
    
document.querySelectorAll('#sortOptions option').forEach(function(option) {
  option.addEventListener('click', function() {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.getAttribute('value'));
    window.location.href = url.href;
  });
});
document.getElementById('sortButton').addEventListener('click', function() {
  document.getElementById('sortOptions').classList.toggle('hidden')
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-content"] && !window.DesignMode) return;
  try {
    
    const carousel = document.getElementById('carousel');
    const prevButton = document.getElementById('prev');
    const nextButton = document.getElementById('next');
    let currentIndex = 0;

    function scrollToIndex(index) {
        const cardWidth = carousel.children[0].offsetWidth + 24; // 24px for gap
        carousel.scrollTo({
            left: index * cardWidth,
            behavior: 'smooth'
        });
    }

    prevButton.addEventListener('click', () => {
        if (currentIndex > 0) {
            currentIndex--;
            scrollToIndex(currentIndex);
        }
    });

    nextButton.addEventListener('click', () => {
        if (currentIndex < carousel.children.length - 1) {
            currentIndex++;
            scrollToIndex(currentIndex);
        }
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-posts-carousel"] && !window.DesignMode) return;
  try {
    
    const carousel = document.getElementById('carousel');
    const prevButton = document.getElementById('prev');
    const nextButton = document.getElementById('next');
    let currentIndex = 0;

    function scrollToIndex(index) {
        const cardWidth = carousel.children[0].offsetWidth + 24; // 24px for gap
        carousel.scrollTo({
            left: index * cardWidth,
            behavior: 'smooth'
        });
    }

    prevButton.addEventListener('click', () => {
        if (currentIndex > 0) {
            currentIndex--;
            scrollToIndex(currentIndex);
        }
    });

    nextButton.addEventListener('click', () => {
        if (currentIndex < carousel.children.length - 1) {
            currentIndex++;
            scrollToIndex(currentIndex);
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-posts"] && !window.DesignMode) return;
  try {
    
document.querySelectorAll('#sortOptions option').forEach(function(option) {
  option.addEventListener('click', function() {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.getAttribute('value'));
    window.location.href = url.href;
  });
});
document.getElementById('sortButton').addEventListener('click', function() {
  document.getElementById('sortOptions').classList.toggle('hidden')
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
/* -- Default JS -- */
  const shopAll = document.getElementById('shop-all');
  const overlay = document.getElementById('overlay');
  const dropdown = document.getElementById('dropdown');
  const dropdownItems = document.querySelectorAll('.dropdown-item');
  const dropdownImages = document.querySelectorAll('[id^="ddimage-"]');
  const mobileMenuOpen = document.getElementById('mobile-menu-open');
  const mobileMenuClose = document.getElementById('mobile-menu-close');
  const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
  const mobileMenu = document.getElementById('mobile-menu');

  shopAll.addEventListener('mouseover', () => {
    overlay.classList.add('show');
    dropdown.style.display = 'flex';
  });

  shopAll.addEventListener('mouseleave', () => {
    overlay.classList.remove('show');
    dropdown.style.display = 'none';
    dropdownImages.forEach((image) => {
      if (image.id !== 'ddimage-default') {
        image.classList.add('hidden');
      } else {
        image.classList.remove('hidden');
      }
    });
  });

  dropdownItems.forEach((item) => {
    item.addEventListener('mouseover', (e) => {
      const imageId = e.currentTarget.getAttribute('data-image-id');
      dropdownImages.forEach((image) => {
        if (image.id === imageId) {
          image.classList.remove('hidden');
        } else {
          image.classList.add('hidden');
        }
      });
    });
  });

  mobileMenuOpen.addEventListener('click', () => {
    mobileMenu.classList.toggle('hidden');
    overlay.classList.toggle('show');
  });
  mobileMenuClose.addEventListener('click', () => {
    mobileMenu.classList.toggle('hidden');
    overlay.classList.toggle('show');
  });
  overlay.addEventListener('click', () => {
    mobileMenu.classList.toggle('hidden');
    overlay.classList.toggle('show');
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
document.querySelectorAll('#sortOptions option').forEach(function(option) {
  option.addEventListener('click', function() {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.getAttribute('value'));
    window.location.href = url.href;
  });
});
document.getElementById('sortButton').addEventListener('click', function() {
  document.getElementById('sortOptions').classList.toggle('hidden')
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info"] && !window.DesignMode) return;
  try {
    
    
    const showButton = (target) => {
      target.classList.remove('hidden');
      target.classList.add('z-10');
      if(!target.classList.contains("isMobile")) target.parentElement.classList.remove('max-w-[200px]');
    }

    const hideButton = (target) => {
      if(!target.classList.contains("isMobile")) target.parentElement.classList.add('max-w-[200px]');
      target.classList.remove('z-10');
      target.classList.add('hidden');
    }

    const toggleInfo = (e) => {
      const isMobile = window.innerWidth < 1024;
      console.log("isMobile:" + isMobile, "Screen width:" + window.innerWidth);
      const childIndex = Array.from(e.parentNode.querySelectorAll(`.info-block${isMobile ? ".isMobile": ".isDesktop"}`)).indexOf(e);
      console.log('Searching for .info-text-' + childIndex + (isMobile ? ".isMobile" : ""));
      const target = document.querySelector('.info-text-' + childIndex + (isMobile ? ".isMobile" : ""));
      console.log('target: ', target);

      if(target.classList?.contains('hidden')) {
        // Target is currently hidden (i.e. another block may be active)
        // Ensure all blocks are hidden
        document.querySelectorAll(`.info-block${isMobile ? ".isMobile": ".isDesktop"}`).forEach((block, index) => {
          console.log('Searching for .info-text-' + index + (isMobile ? ".isMobile" : ""));
          const targetBlock = document.querySelector('.info-text-' + index + (isMobile ? ".isMobile" : ""));
          console.log('targetBlock: ', targetBlock);
          if(!targetBlock.classList?.contains('hidden')) {
            hideButton(targetBlock);
          }
          console.log('targetBlock: ', targetBlock);
        });
        showButton(target);
      } else {
        // Target is currently active (hide it again)
        hideButton(target);
      }
    }

    // Add listeners to tooltips
    window.addEventListener('DOMContentLoaded', async () => {
      document.querySelectorAll('.info-block').forEach(block => block.addEventListener('click', (e) => {toggleInfo(block)}));
    });
    // Hide info text on scroll for mobile
    window.addEventListener('scroll', () => {
      const isMobile = window.innerWidth < 1024;
      // If not mobile do nothing
      if(!isMobile) return;
      // Ensure all blocks are hidden
      document.querySelectorAll(`.info-block.isMobile`).forEach((block, index) => {
        console.log('Searching for .info-text-' + index + (isMobile ? ".isMobile" : ""));
        const targetBlock = document.querySelector('.info-text-' + index + (isMobile ? ".isMobile" : ""));
        console.log('targetBlock: ', targetBlock);
        if(!targetBlock.classList?.contains('hidden')) {
          hideButton(targetBlock);
        }
        console.log('targetBlock: ', targetBlock);
      });

    })
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["select-blog-posts"] && !window.DesignMode) return;
  try {
    
document.querySelectorAll('#sortOptions option').forEach(function(option) {
  option.addEventListener('click', function() {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.getAttribute('value'));
    window.location.href = url.href;
  });
});
document.getElementById('sortButton').addEventListener('click', function() {
  document.getElementById('sortOptions').classList.toggle('hidden')
});

  } catch(e) { console.error(e); }
})();
})();
